<template>
  <div class="row">
    <div class="col-md-12">
      <loading v-if="! showContent"></loading>
      <h2 class="titulo"> {{ bloco.nome }} </h2>
      <a :href="returnLink(item)" v-if="isPageTarget(item)" :target="linkBlank(item)" class="espaco_publicitario">
        <img v-if="item.image" :src="item.image">
        <div v-if="item.contentHtml" v-html="item.contentHtml"></div>
      </a>
      <router-link :to="item.link" v-if="!isPageTarget(item)" targ class="espaco_publicitario">
        <img v-if="item.image" :src="item.image">
        <div v-if="item.contentHtml" v-html="item.contentHtml"></div>
      </router-link>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Publicidade',
        showContent: true,
        item: {},
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      get('content/' + this.bloco.id).then(function (response) {
        if(response.data.result.data){
          self.showContent = true;
          self.item = response.data.result.data;
        }
      });
    },
    methods: {
      rotaPagina(item) {
        if (item.link_interno == 0) {
          return true;
        }
      },
      isPageOpenInsede(item){
        if (item.link_interno == '1' && item.target == '1') {
          return true;
        }
        return false;
      },
      isPageTarget(item) {
        // se for abir em nova janela retorna true
        if (item.target == '1') {
          return true;
        }
        //se for apenas um link, retorna true
        if(item.link_interno != "1"){
          return true;
        }
        return false;
      },
      returnLink(item) {
        if (item.link !== null) {
          return item.link;
        }
        return null;
      },
      linkBlank(item) {
        if (item.target == '1') {
          return '_blank'
        }
        return '_self';
      }
    },
    computed:{
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/Publicity.vue